
import createjs, { Point, Shape } from 'createjs-module'

import { Spots } from './../Spots'
import { Spot, SpotModelViewDto } from './../spot/Spot'

import {
    EVENT_TYPE_ADD_SPOTS_GRID_COMPLETED,

    EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS,

    EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A,
    EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED,

    dispatchEventType,
    addEventTypeListener,
    removeEventTypeListener
} from '../../../../../globals/EventDispatcher'
import { Dimensions } from '../../../../../globals/Dimensions';
import { FlyerPageSpotDto } from '../../../../../dtos';

import {
    FLYER_SPOTS_MIN_HEIGHT_PX, FLYER_SPOTS_MIN_WIDTH_PX,
    getCanvasElementsScales,
} from '../../../../../globals'
import { SpotsCollisionManager } from './../collisionManagers/SpotsCollisionManager';
import { CustomDataEvent } from '../../../../../globals/CustomDataEvent';


export class SpotsScallingManager {

    private _mainSpotsContainer: Spots | null = null;

    private _collisionManager: SpotsCollisionManager | null = null;

    constructor(spotsContainer: Spots) {
        this._mainSpotsContainer = spotsContainer;
        this._collisionManager = new SpotsCollisionManager();
    }

    public onMainSpotsContainerPressMove = (mouseEvent: any) => {

        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.isInScallingIndividualSpotsMode){
            return;
        }

        let innerSpots = mainContainer.innerSpots

        if (!mainContainer.isPageContainer) {
            return;
        }

        if (!mainContainer.nextGgridSize) {
            return;
        }

        if (!mainContainer.isMouseDown) {
            mainContainer.isMouseDown = true;

            var mouseX = mouseEvent.stageX;
            var mouseY = mouseEvent.stageY;

            //
            if (this._collisionManager!.isMinimalGridHasCollisions(mainContainer, mouseX, mouseY)) 
            {
                let miniamlDimensions = mainContainer.spotsFunctions!.getNextGridMinimalDimensions(mainContainer.nextGgridSize!);

                mainContainer.redStokedShape = mainContainer.spotsFunctions!.createRedStroke(
                    mouseX,
                    mouseY,
                    miniamlDimensions.width!,
                    miniamlDimensions.height!
                );

                mainContainer.addChild(mainContainer.redStokedShape);
                mainContainer.updateStage()

                return;
            }

            this.reInitiAllCollidersState();


            //
            var mouseX = mouseEvent.stageX;
            var mouseY = mouseEvent.stageY;
            mainContainer.mouseX0 = mouseX
            mainContainer.mouseY0 = mouseY
            mainContainer.lastMouseX = mouseX;
            mainContainer.lastMouseY = mouseY;
            mainContainer.currentSpotsContainer = mainContainer.spotsFunctions!.addInitialGrid(mouseX, mouseY)

        }
        else {
            if (mainContainer.currentSpotsContainer) {
                if(!mainContainer.isInCollisionState) {
                    mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
                    mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
                    mainContainer.canvasMouseTracker!.showMouseIcon('framesGridCreationIcon');
                }
                this.handleNewGridLiveScale(mouseEvent);
            }
        }
    }

    public onMainSpotsContainerPressUp = (mouseEvent: any) => {
        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.isInScallingIndividualSpotsMode){
            mainContainer.isInScallingIndividualSpotsMode = false;
            this.handleScallingMouseUpForSelectedSpots();
            return;
        }

        if(mainContainer.isInMoveSpotsMode){
            mainContainer.isInMoveSpotsMode = false;
            mainContainer.spotsTranslationManager!.handleScallingMouseUpForMovedSpots();
            return;
        }

        if (!mainContainer.isPageContainer) {
            return;
        }

        let isRedStrokeVisible = mainContainer.redStokedShape && mainContainer.redStokedShape.visible ? true : false;

        if (mainContainer.redStokedShape) {
            if (isRedStrokeVisible) {

                // if visible => _currentSpotsContainer size is less than the minimal dimentions
                if (mainContainer.currentSpotsContainer!) {
                    mainContainer.innerSpots.pop();
                    mainContainer.removeChild(mainContainer.currentSpotsContainer!)
                }
            }
            else {
                // if _redStokedShape is not visible => grid dimensions >= minimal size
                // in that case we can consider the current grid creation as done
                mainContainer.nextGgridSize = null;
            }

            mainContainer.redStokedShape.parent.removeChild(mainContainer.redStokedShape)
            mainContainer.redStokedShape = null;

            mainContainer.updateStage()
        }

        if (!isRedStrokeVisible && !mainContainer.isInCollisionState) {
            mainContainer.spotsFunctions!.extractSpotsFromTheirContainer(mainContainer.currentSpotsContainer!);
        }

        if(mainContainer.isInCollisionState) 
        {
            if(mainContainer.currentSpotsContainer) 
            {
                if(mainContainer.currentSpotsContainer!.parent){
                    mainContainer.currentSpotsContainer!.parent.removeChild(mainContainer.currentSpotsContainer!);
                }
                mainContainer.currentSpotsContainer!.removeAllChildren();
                mainContainer.currentSpotsContainer = null;
            }
        }

        mainContainer.isMouseDown = false;
        mainContainer.isInCollisionState = false;

        mainContainer.canvasMouseTracker!.hideIcon('framesGridCreationIcon');
        mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
        mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
    }

    private preStartDraggingFromCorner(event: CustomDataEvent){
        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if(selectedSpots.length === 0) {
            return;
        }

        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;
        mouseEvent.stopPropagation();

        if(!mainContainer.isInScallingIndividualSpotsMode) 
        {
            mainContainer.isInScallingIndividualSpotsMode = true;

            var mouseX = mouseEvent.stageX;
            var mouseY = mouseEvent.stageY;
            mainContainer.mouseX0 = spot.x
            mainContainer.mouseY0 = spot.y
            mainContainer.lastMouseX = mouseX;
            mainContainer.lastMouseY = mouseY;

            let spotsDtos: SpotModelViewDto[] = []
            mainContainer.currentSelectedSpotsDtos = spotsDtos;
            
            
            for (let i = 0; i < selectedSpots.length; i++) 
            {
                const currentSpot = selectedSpots[i];

                // VERY IMPORTANT
                currentSpot.updateOriginalDImensions(); 

                const currentSpotBounds = currentSpot.getBounds();

                let x0 = currentSpot.x;
                let y0 = currentSpot.y;

                let spotDto: FlyerPageSpotDto | null;

                if(currentSpot.initialData) {
                    spotDto = currentSpot.initialData
                }
                else {
                    spotDto = {
                        fpsX0px: x0,
                        fpsY0px: y0,
                        fpsWidthPx: currentSpotBounds.width,
                        fpsHeightPx: currentSpotBounds.height
                    }
                }

                currentSpot.initialData = spotDto

                let mvDto = { dto: spotDto, spot: currentSpot }

                if(spot === currentSpot) {
                    mainContainer.currentSelectedSpotScallerDto = mvDto
                }

                spotsDtos.push(mvDto)
            }
        }
    }

    public liveDragFromBottomRight(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.innerSpots.length === 0){
            return;
        }

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if(selectedSpots.length === 0) {
            return;
        }

        //
        this.preStartDraggingFromCorner(event)

        //
        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.mouseX0 + generatedWidth
        mainContainer.lastMouseY = mainContainer.mouseY0 + generatedHeight

        let currentSelectedSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
        let currentSelectedSpotScallerSpotDto = currentSelectedSpotScallerDto!.dto!;

        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!

        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!
            const spotDto = item.dto!;
            // const container = spot.parent as Spots;
            
            let scaleX = generatedWidth / currentSelectedSpotScallerSpotDto.fpsWidthPx!
            let scaleY = generatedHeight / currentSelectedSpotScallerSpotDto.fpsHeightPx!

            //
            let normalizedScale = this._collisionManager?.normalizeScallings(mainContainer, item, scaleX, scaleY);
            scaleX = normalizedScale!.x;
            scaleY = normalizedScale!.y;
            
            // individual spots
            spot.updateScale(scaleX, scaleY) 
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unSelectedSpots =  mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForDraggingSelectedSpots(currentSpots, unSelectedSpots);

        mainContainer.updateStage()
    }

    public liveDragFromBottomLeft(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.innerSpots.length === 0){
            return;
        }
        
        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if(selectedSpots.length === 0) {
            return;
        }

        //
        this.preStartDraggingFromCorner(event) 

        //
        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        //
        let currentSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
        let currentSpotScallerSpotDto = currentSpotScallerDto!.dto!;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.currentMouseX
        mainContainer.lastMouseY = mainContainer.mouseY0 + generatedHeight
    
        //
        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!

        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!
            const spotDto = item.dto!;

            let scaleX = (currentSpotScallerSpotDto.fpsWidthPx! - generatedWidth)  / currentSpotScallerSpotDto.fpsWidthPx!
            let scaleY = generatedHeight / currentSpotScallerSpotDto.fpsHeightPx!

            //
            let normalizedScale = this._collisionManager?.normalizeScallings(mainContainer, item, scaleX, scaleY);
            scaleX = normalizedScale!.x;
            scaleY = normalizedScale!.y;

            // individual spots
            spot.updateScale(scaleX, scaleY) 
            spot.x = spotDto.fpsX0px! + spotDto.fpsWidthPx! * (1 - scaleX)
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unSelectedSpots =  mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForDraggingSelectedSpots(currentSpots, unSelectedSpots);

        mainContainer.updateStage()
    }

    public liveDragFromTopLeft(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.innerSpots.length === 0){
            return;
        }

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if(selectedSpots.length === 0) {
            return;
        }

        //
        this.preStartDraggingFromCorner(event)

        //
        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        //
        let currentSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
        let currentSpotScallerSpotDto = currentSpotScallerDto!.dto!;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.currentMouseX
        mainContainer.lastMouseY = mainContainer.currentMouseY
    
        //
        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!

        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!
            const spotDto = item.dto!;

            let scaleX = (currentSpotScallerSpotDto.fpsWidthPx! - generatedWidth)  / currentSpotScallerSpotDto.fpsWidthPx!
            let scaleY = (currentSpotScallerSpotDto.fpsHeightPx! - generatedHeight)  / currentSpotScallerSpotDto.fpsHeightPx!
            
            //
            let normalizedScale = this._collisionManager?.normalizeScallings(mainContainer, item, scaleX, scaleY);
            scaleX = normalizedScale!.x;
            scaleY = normalizedScale!.y;

            // individual spots
            spot.updateScale(scaleX, scaleY) 
            spot.x = spotDto.fpsX0px! + spotDto.fpsWidthPx! * (1 - scaleX)
            spot.y = spotDto.fpsY0px! + spotDto.fpsHeightPx! * (1 - scaleY)
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unSelectedSpots =  mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForDraggingSelectedSpots(currentSpots, unSelectedSpots);

        mainContainer.updateStage()
    }

    public liveDragFromTopRight(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        if(mainContainer.innerSpots.length === 0){
            return;
        }

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if(selectedSpots.length === 0) {
            return;
        }

        //
        this.preStartDraggingFromCorner(event)

        //
        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        //
        let currentSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
        let currentSpotScallerSpotDto = currentSpotScallerDto!.dto!;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.mouseX0 + generatedWidth
        mainContainer.lastMouseY = mainContainer.currentMouseY

        let miniamlDimensions = mainContainer.spotsFunctions!.getNextGridMinimalDimensions(new Point(1, 1))
    
        //
        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!

        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!
            const spotDto = item.dto!;

            let scaleX = generatedWidth  / currentSpotScallerSpotDto.fpsWidthPx!
            let scaleY = (currentSpotScallerSpotDto.fpsHeightPx! - generatedHeight)  / currentSpotScallerSpotDto.fpsHeightPx!

            //
            let nextWidth = spot.originalWidth * scaleX;
            let nextHeight = spot.originalHeight * scaleY;
            
            if (nextWidth <= miniamlDimensions.width!) {
                scaleX = miniamlDimensions.width! / spotDto.fpsWidthPx!
            }
            if (nextHeight <= miniamlDimensions.height!) {
                scaleY = miniamlDimensions.height! / spotDto.fpsHeightPx!
            }  

            let normalizedScale = this._collisionManager?.normalizeScallings(mainContainer, item, scaleX, scaleY);
            scaleX = normalizedScale!.x;
            scaleY = normalizedScale!.y;

            // individual spots
            spot.updateScale(scaleX, scaleY) 
            // spot.x = spotDto.fpsX0px! + spotDto.fpsWidthPx! * (1 - scaleX)
            spot.y = spotDto.fpsY0px! + spotDto.fpsHeightPx! * (1 - scaleY)
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unSelectedSpots =  mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForDraggingSelectedSpots(currentSpots, unSelectedSpots);

        mainContainer.updateStage()
    }    

    public handleNewGridLiveScale(mouseEvent: any) {

        let mainContainer = this._mainSpotsContainer!

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        // let collidedObjects = this._collisionManager!.getInternalCollidedObjects(mainContainer, generatedWidth, generatedHeight);
        // console.log(collidedObjects.length)
        // console.log(collidedObjects)
        // let updateMousePoisition = this._collisionManager!.handleLiveScallingCollisions(mainContainer, mainContainer.currentMouseX, mainContainer.currentMouseY, collidedObjects);
        // mainContainer.currentMouseX = updateMousePoisition.x
        // mainContainer.currentMouseY = updateMousePoisition.y

        // update generated width and height
        generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.mouseX0 + generatedWidth
        mainContainer.lastMouseY = mainContainer.mouseY0 + generatedHeight

        if (generatedWidth <= 0) {
            generatedWidth = 0;
        }
        if (generatedHeight <= 0) {
            generatedHeight = 0
        }

        var columns = mainContainer.nextGgridSize?.x!;
        var rows = mainContainer.nextGgridSize?.y!;

        // console.log(generatedWidth, generatedHeight)

        let innerSpotsContainer = mainContainer.currentSpotsContainer!

        let realFlyerWidth = this._mainSpotsContainer!._flyerPageDto?.flpWidthPx!
        let realFlyerHeight = this._mainSpotsContainer!._flyerPageDto?.flpHeightPx!

        let scale = getCanvasElementsScales(realFlyerWidth, realFlyerHeight);

        let minWidth = FLYER_SPOTS_MIN_WIDTH_PX * scale.scaleX;
        let minHeight = FLYER_SPOTS_MIN_HEIGHT_PX * scale.scaleY;

        // spots container
        let nextBackgroundScaleX = generatedWidth / (columns * minWidth)
        let nextBackgroundScaleY = generatedHeight / (rows * minHeight)
        innerSpotsContainer.backgroundScale(nextBackgroundScaleX, nextBackgroundScaleY)

        // individual spots
        let nextSpotWidth = generatedWidth / columns
        let nextSpotHeight = generatedHeight / rows
        let nextScaleX = nextSpotWidth / minWidth
        let nextScaleY = nextSpotHeight / minHeight
        this.updateSpotsBackgroundPosition(nextScaleX, nextScaleY)

        if (!mainContainer.currentSpotsContainer!.visible) {
            mainContainer.currentSpotsContainer!.visible = true;
        }

        let miniamlDimensions = mainContainer.spotsFunctions!.getNextGridMinimalDimensions(mainContainer.nextGgridSize!);
        if (generatedWidth < miniamlDimensions.width! || generatedHeight < miniamlDimensions.height!) {
            // show red zone
            if (mainContainer.redStokedShape === null) {
                mainContainer.redStokedShape = mainContainer.spotsFunctions!.createRedStroke(mainContainer.mouseX0, mainContainer.mouseY0, miniamlDimensions.width!, miniamlDimensions.height!);
                mainContainer.addChild(innerSpotsContainer)
                mainContainer.addChild(mainContainer.redStokedShape)
            }

            mainContainer.redStokedShape.visible = true;
        }
        else {
            if (mainContainer.redStokedShape) {
                mainContainer.redStokedShape.visible = false;
            }
        }

        //
        let currentSpots = mainContainer.currentSpotsContainer!.innerSpots.map(spot => {
            let newSpot = new Spot(mainContainer)
            newSpot.setBounds(0, 0, spot.getBounds().width, spot.getBounds().height);
            newSpot.x = mainContainer.currentSpotsContainer!.x + spot.x;
            newSpot.y = mainContainer.currentSpotsContainer!.y + spot.y;
            return newSpot;
        })
        let otherSpots = mainContainer.innerSpots
        this.handleCollisionsStateForFirstGridCreation(currentSpots, otherSpots);

        mainContainer.updateStage()
    }

    private handleCollisionsStateForFirstGridCreation(currentSpots: Spot[], otherSpots: Spot[]){
        let mainContainer = this._mainSpotsContainer!;

        let hasCollisions = this._collisionManager?.hasCollisionsBetweenSpots(currentSpots, otherSpots)
        if(hasCollisions) {
            console.log(`hasCollisions: ${hasCollisions}`)
            mainContainer.isInCollisionState = true;
            mainContainer.canvasMouseTracker!.hideIcon('framesGridCreationIcon');
            mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
            mainContainer.canvasMouseTracker!.showMouseIcon('noAccessIcon');
        }
        else {
            mainContainer.isInCollisionState = false;
        }
    }

    private handleCollisionsStateForDraggingSelectedSpots(currentSpots: Spot[], otherSpots: Spot[]){
        let mainContainer = this._mainSpotsContainer!;

        let hasCollisions = this._collisionManager?.hasCollisionsBetweenSpots(currentSpots, otherSpots)
        if(hasCollisions) {
            console.log(`hasCollisions: ${hasCollisions}`)
            mainContainer.isInCollisionState = true;
            mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
            mainContainer.canvasMouseTracker!.showMouseIcon('noAccessIcon', true);
        }
        else {
            mainContainer.isInCollisionState = false;
            mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
            // mainContainer.canvasMouseTracker!.showMouseIcon('moveFramesIcon', true);
        }
    }

    private handleScallingMouseUpForSelectedSpots(){

        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = mainContainer.currentSelectedSpotsDtos!.map(mvDto =>  mvDto.spot! )
        let innerSpots =  mainContainer.innerSpots;
        let hasCollisions = this._collisionManager!.hasCollisionsBetweenSpots(selectedSpots, innerSpots)

        if(hasCollisions) {
            let currentSelectedSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
            let currentSelectedSpotScallerSpotDto = currentSelectedSpotScallerDto!.dto!;

            let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!
            
            for (let i = 0; i < seleectedSpotsDto.length; i++) {
                let item = seleectedSpotsDto[i];
                const spot = item.spot!
                const spotDto = item.dto!;

                let scaleX = 1
                let scaleY = 1

                console.log(scaleX, scaleY);

                // individual spots
                spot.updateScale(scaleX, scaleY) 
                spot.x = spotDto.fpsX0px!;
                spot.y = spotDto.fpsY0px!;
            }

            mainContainer.updateStage();
        }
        else {
            //
            let selectedSpots = mainContainer.spotsFunctions?.getSelectedSpots(true);
            let updatedSpotsDtos: FlyerPageSpotDto[] = selectedSpots!.map(spot => {
                return spot.updatedData;
            })
            mainContainer.persistenceManager?.prepareSpotsForSaving(updatedSpotsDtos);
        }

        //
        mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
        mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
    }

    

    public updateSpotsBackgroundPosition(scaleX: number, scaleY: number, updatePosition: boolean = true) {

        let mainContainer = this._mainSpotsContainer!
        let innerSpotsContainer = mainContainer.currentSpotsContainer!

        for (let i = 0; i < innerSpotsContainer.children.length; i++) {
            const child = innerSpotsContainer.children[i];
            if (child instanceof Spot) {
                child.updateScale(scaleX, scaleY)

                if(updatePosition) {
                    child.updatePositionByScale(scaleX, scaleY)
                }
            }
        }
    }

    public reInitiAllCollidersState() {
        let mainContainer = this._mainSpotsContainer!

        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const element = mainContainer.innerSpots[i];
            //element.isBottomCollider = false;
           // element.isRightCollider = false;
        }
    }

}